var GenericView = require('views/generic.view.ts');
var Handlebars = require('handlebars');
var Template = require('text-loader!../../templates/results/cost_effective.results.template.html');
var Handlebars = require('../../../libs/handlebars/handlebars-v4.0.5.js');

var TheView = GenericView.extend({
    el: '#costEffective',
    tagName: '',
	template: Handlebars.compile(Template),
	data: null,
	months: [{number:1, name: 'January'}, {number:2, name: 'February'}, {number:3, name: 'March'}, {number:4, name: 'April'}, {number:5, name: 'May'}, {number:6, name: 'June'}, {number:7, name: 'July'}, {number:8, name: 'August'}, {number:9, name: 'September'}, {number:10, name: 'October'}, {number:11, name: 'November'}, {number:12, name: 'December'}],
	initialize: function (options) {
        this.data = options.data;
        this.render();
    },
    superRender: GenericView.prototype.render,
    render: function () {
        var self = this;
        this.superRender();
        this.$el.html(this.template(this.data));

        var years = [];
        $.each( self.data.cashFlows.cashFlowsIn, function( index, value ) {
          years.push(index+1);
        });

        GenericView.prototype.createBarChart('costEffective-monthly_scr', 'Monthly SCR (%)', '', '', this.data.tableSCR, [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
        GenericView.prototype.createBarChart('costEffective-monthly_ssr', 'Monthly SSR (%)', '', '', this.data.tableSSR, [], ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"], '', '', '#4472c4', '', false);
        GenericView.prototype.createBarChart('costEffective-cash_flow', 'Cash flow per year (€)', '', '', this.data.cashFlows.cashFlowsIn, this.data.cashFlows.cashFlowsOut, years, 'CashInFlows', 'CashOutFlows', '#4472c4', '#ed7d31', true);
        this.cashEffective();

    },
    events: {

    },
    cashEffective: function() {
        var batterySize = this.data.tableToCompare[0];
        var pvSize = this.data.tableToCompare[1];
        var ssr = this.data.tableToCompare[2];
        var npv = this.data.tableToCompare[3];

        var data = [];
        for (var i=0; i<10; i++) {
            var temp = {x: ssr[i], y: npv[i]};
            data.push(temp);
        }
        console.log(data);

        var self = this;
        var ctx = document.getElementById('costEffective-solutions').getContext('2d');

        var myChart = new Chart(ctx, {
            type: 'scatter',
            data: {
                datasets: [{
                    data: data,
                    battery: batterySize,
                    pv: pvSize,
                    borderColor: "#4472c4",
                    fill: false,
                }],
            },
            options: {
                responsive: true,
                aspectRatio: 3,
                maintainAspectRatio: false,
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: 'Cost effective solutions',
                    fontSize: '20',
                },
                scales: {
                    xAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: "SSR (%)"
                        }
                    }],
                    yAxes: [{
                        display: true,
                        scaleLabel: {
                            display: true,
                            labelString: "NPV (€)"
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: ()=>null,
                        title: ()=>null,
                        beforeFooter: function(item, everything) {
                            let index = item[0].index;

                            if (index >= 0) {
                                let battery_value = everything.datasets[0].battery[index];

                                return 'Battery = ' + battery_value + ' kWh';
                            } else {
                                return;
                            }
                        },
                        footer: function(item, everything) {
                            let index = item[0].index;

                            if (index >= 0) {
                                let pv_value = everything.datasets[0].pv[index];

                                return 'PV = ' + pv_value + ' kWp';
                            } else {
                                return;
                            }
                        }
                    }
                }
              }
        });

        myChart.canvas.parentNode.style.height = '350px';
        myChart.canvas.parentNode.style.width = '90%';
    },
});

module.exports= TheView;